"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRadio = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
exports.StyledRadio = styled_1.default.div `
	cursor: pointer;

	.merlin-radio__container {
		display: flex;
		align-items: center;
		position: relative;
	}

	/* Hide default radio button but allow for tab selection */
	.merlin-radio__input {
		z-index: -1;
		position: absolute;
		left: 2px;
	}

	/*
		This radio__button selector only handles the outline of the
		button, the radio__button:before is the thicker inner border
	*/
	.merlin-radio__button {
		flex: none;
		margin-right: 10px;
		position: relative;
		box-sizing: border-box;
		background: white;
		border: 1px solid ${merlin_theme_1.default.colours.neutral.medium};
		width: 45px;
		height: 45px;
		border-radius: 50%;

		transition: border 0.2s;
	}
	.merlin-radio__button:hover {
		cursor: pointer;
		border: 1px solid ${merlin_theme_1.default.colours.neutral.dark};
	}

	/*
		Checked and focus behaviour.  Focus changes the outline colour
		and checked has a wide inner border.  Note the outline is
		widened when checked & focussed to blend the two borders better
	*/
	.merlin-radio__input:checked + .merlin-radio__button:before {
		content: '\\e908';
		font-family: ${merlin_theme_1.default.typography.fonts.icons};
		font-weight: 800;
		color: ${merlin_theme_1.default.colours.neutral.darker};
		-webkit-font-smoothing: antialiased;
		font-size: 2rem;
		display:inline-block;
		transform: translate(32%, 30%);
		width: 16px;
		height: 16px;
	}
	.merlin-radio__input:focus + .merlin-radio__button:after {
		width: 49px;
		height: 49px;
		border-radius: 50%;
		border: 1px solid ${merlin_theme_1.default.colours.highlight.default};
		position: absolute;
		content: "";
		top: ${(props) => props.top ? `${props.top}px` : '-3px'};
		left: ${(props) => props.left ? `${props.left}px` : '-3px'};
	}

	.merlin-radio__label {
		${merlin_theme_1.default.typography.b1}
		cursor: pointer;
	}

`;
//# sourceMappingURL=Radio.styled.js.map